module.exports = __webpack_public_path__ + "img/githubcopilot.b77ef2b6.svg";